import { render, staticRenderFns } from "./FilteredList.vue?vue&type=template&id=04733996&scoped=true"
import script from "./FilteredList.vue?vue&type=script&lang=js"
export * from "./FilteredList.vue?vue&type=script&lang=js"
import style0 from "./FilteredList.vue?vue&type=style&index=0&id=04733996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04733996",
  null
  
)

export default component.exports